module.exports = __webpack_public_path__ + "img/miguel-hernandez.ba6e4170.jpg";